// extracted by mini-css-extract-plugin
export default {"swiper":"session-view_swiper__SFXHG","slide":"session-view_slide__U49QL","pagination":"session-view_pagination__JjPxt","disabled":"session-view_disabled__NBZeX"};